import { InputLabel, MenuItem } from '@mui/material';
import { memo, useEffect } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ValoreDominioVO } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

export interface ItemUFCVM extends ItemVM {
  name?: string;
  surname?: string;
}

interface ListUfcDelegateProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (item?: ItemUFCVM) => void;
  error?: boolean;
  isSmallSize?: boolean;
  label: string;
  idValorePadre: string;
  betweenFrom?: number;
  betweenTo?: number;
}

const ListUfcDelegateComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  label,
  idValorePadre,
  betweenFrom,
  betweenTo,
}: ListUfcDelegateProps): React.ReactElement => {
  const [states, getStates] = useHttpFetch<HttpResponse<Array<ValoreDominioVO>>, Array<ItemUFCVM>>(
    `${__ACT_API_URL__}/valori-dominio-atti/id-dominio/9/id-dominio-padre/8/id-valore-padre/${idValorePadre}`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response) => {
        let castedResponse = (response.data.payload || []) as Array<ValoreDominioVO>;

        if (betweenFrom && betweenTo) {
          castedResponse = castedResponse.filter(
            (item) =>
              Number.parseInt(item.key?.idValore || '', 10) >= betweenFrom &&
              Number.parseInt(item.key?.idValore || '', 10) <= betweenTo
          );
        }

        return castedResponse.map((item) => ({
          id: item.key?.idValore,
          value: `${item.descrizioneBreveValore || ''} ${item.valore || ''}`,
          name: item.descrizioneBreveValore || '',
          surname: item.valore || '',
        })) as Array<ItemUFCVM>;
      },
    }
  );

  useEffect(() => {
    if (idValorePadre) {
      getStates();
    }
  }, [idValorePadre]);

  const statesData: Array<ItemUFCVM> = (states.data || []) as Array<ItemUFCVM>;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="state-label">
        {required ? `${label} *` : label}
      </InputLabel>
      <PmiSelect
        labelId="state-label"
        id="state"
        name="state"
        value={value}
        label={required ? `${label} *` : label}
        onChange={(event) => onChange(statesData?.find((item) => item.id === event.target.value))}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {statesData?.map((state: ItemUFCVM) => (
          <MenuItem key={state.id} value={state.id}>
            {state.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListUfcDelegateComponent.displayName = 'List UFC Delegate component';

const ListUfcDelegate = memo(ListUfcDelegateComponent);

export default ListUfcDelegate as typeof ListUfcDelegateComponent;
